import { BudgetPreviewsStatus } from '@components/shared/BudgetPreviewsStatus'

import type { ConsolidatedHeaderCardProps } from './types'

import * as S from './styles'

export const ConsolidatedHeaderCard = ({
  unitLabel,
  competenceLabel,
  title = 'Lançamento Consolidado',
  subtitle = 'Preencha os valores por semana. O sistema calculará o GP e o GM automaticamente.',
  status
}: ConsolidatedHeaderCardProps) => {
  return (
    <S.Container>
      <S.TopRow>
        <S.Chips>
          <S.FilledChip>{unitLabel}</S.FilledChip>
          <S.OutlinedChip>{competenceLabel}</S.OutlinedChip>
        </S.Chips>

        {!!status && <BudgetPreviewsStatus status={status} />}
      </S.TopRow>

      <S.Title>{title}</S.Title>
      <S.Subtitle>{subtitle}</S.Subtitle>
    </S.Container>
  )
}
